import { render, staticRenderFns } from "./apps.vue?vue&type=template&id=0143c1cb&scoped=true"
import script from "./apps.vue?vue&type=script&lang=js"
export * from "./apps.vue?vue&type=script&lang=js"
import style0 from "./apps.vue?vue&type=style&index=0&id=0143c1cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0143c1cb",
  null
  
)

export default component.exports